<template>
  <div>
    <Breadcrumbs main="User" title="List User" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <px-card :actions="false">
            <div class="p-4">
              <b-row>
                <b-col xl="12" class="mb-4 text-right">
                  <b-button
                    id="default-sm-primary"
                    variant="primary"
                    size="md"
                    @click="nextPage()"
                    >Tambah User</b-button
                  >
                </b-col>
                <b-col xl="6">
                  <b-input-group class="datatable-btn">
                    <b-form-input
                      v-model="filter"
                      placeholder="Cari Users"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''"
                        >Clear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-col>

                <b-col xl="6">
                  <b-form-group
                    label-cols="2"
                    label="Per page"
                    class="mb-0 datatable-select"
                  >
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue">
                <b-table
                  show-empty
                  :items="items"
                  :fields="tablefields"
                  :filter="filter"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @filtered="onFiltered"
                >

                  <template v-slot:cell(fullname)="row">
                    {{ row.item.fullname }}
                  </template>

                  <template v-slot:cell(username)="row">
                    {{ row.item.username }}
                  </template>

                  <template v-slot:cell(phone_number)="row">
                    {{ row.item.phone_number ? row.item.phone_number : "-" }}
                  </template>

                  <template v-slot:cell(action)="row">
                    <div class="btn-showcase">
                      <b-button
                        id="default-sm-primary"
                        variant="secondary"
                        size="sm"
                        @click="editDataUser(row.item.id)"
                        >Edit Account</b-button
                      >
                      <b-button
                        id="default-sm-primary"
                        variant="warning"
                        @click="detailUser(row.item.id)"
                        size="sm"
                        >Edit Profile</b-button
                      >
                    </div>
                  </template>
                </b-table>
              </div>
              <b-col md="6" class="p-0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </div>
          </px-card>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { listUser } from "../../_services";

export default {
  name: "GeneralWidgets",
  data() {
    return {
      donutchart: [],
      dataChartData: [],
      dataClass: [],
      options: [
        { code: 1, name: "Alabama" },
        { code: 2, name: "Wyoming" },
        { code: 3, name: "Coming" },
        { code: 4, name: "Hanry Die" },
        { code: 5, name: "John Doe" },
      ],
      roleModelOption: [],
      role: "",
      tablefields: [
        { key: "profile", label: "" },
        { key: "fullname", label: "Name", sortable: true },
        { key: "username", label: "Username", sortable: true },
        { key: "phone_number", label: "Nomor Hp", sortable: true },
        { key: "action", label: "Action", sortable: true },
      ],
      demografis: {
        education: [],
      },
      items: [],
      filter: null,

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
    };
  },
  async mounted() {
    this.fetchDataUsers();
  },
  methods: {
    nextPage() {
      this.$router.push({ path: "/user/create" });
    },
    async fetchDataUsers() {
      let data = await listUser();
      this.items = data;
      this.totalRows = this.items.length;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getImgUrl() {
      let idx = Math.floor(Math.random() * 10);
      return require("../../assets/images/user/" +
        (idx == 0 ? 1 : idx) +
        ".jpg");
    },
    detailUser(id_user) {
      this.$router.push({
        path: "/user",
        query: {
          id_user: id_user,
        },
      });
    },
    editDataUser(id) {
      this.$router.push({
        path: "/user/update",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
